// extracted by mini-css-extract-plugin
module.exports = {"marginLeft":"styles_marginLeft__2th_B"};